<div class="popup-overlay-camera modal-confirm confiram-fail">
  <div class="popup-warp">
      <div class="popup-inner pad-popup">
          <div class="content-popup">
              <div class="icon-popup"><img src="assets/img/unilever-icon.png"></div>
              <p class="des-popup">Quà đã hết, vui lòng cập nhật thêm quà</p>
              <div class="group-btn-inline">
                  <button type="button" class="btn btn-confirm" id="close-modal" (click)="close()">Đóng</button>
                  <button type="button" class="btn btn-primary" id="go-gift-2" (click)="navigateGiftStore()">Đến kho quà</button>
              </div>
          </div>
      </div>
  </div>
</div>